var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _ellipse, _g9, _g10, _circle, _g11, _g12, _circle2, _g13, _g14, _g15, _ellipse2, _g16, _g17, _g18, _g19, _g20, _g21, _g22, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgStable(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 144,
    height: 144,
    viewBox: "0 0 144 144",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_694_2686)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 115.842,
    cy: 98.6971,
    r: 14.1065,
    transform: "rotate(30 115.842 98.6971)",
    fill: "#63CADA"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 115.842,
    cy: 98.6971,
    r: 14.1065,
    transform: "rotate(30 115.842 98.6971)",
    fill: "url(#paint0_radial_694_2686)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_f_694_2686)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 120.204,
    cy: 98.8307,
    rx: 5.12964,
    ry: 5.12964,
    transform: "rotate(-142.415 120.204 98.8307)",
    fill: "#9CF2FF"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_d_694_2686)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 28.0602,
    cy: 98.6975,
    r: 14.1065,
    transform: "rotate(150 28.0602 98.6975)",
    fill: "#63CADA"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 28.0602,
    cy: 98.6975,
    r: 14.1065,
    transform: "rotate(150 28.0602 98.6975)",
    fill: "url(#paint1_radial_694_2686)"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_f_694_2686)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 25.7625,
    cy: 102.409,
    r: 5.12964,
    transform: "rotate(-22.4147 25.7625 102.409)",
    fill: "#9CF2FF"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter4_d_694_2686)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 80.1176,
    y: 119.474,
    width: 33.8541,
    height: 5.64106,
    rx: 2.82053,
    transform: "rotate(-30 80.1176 119.474)",
    stroke: "url(#paint2_radial_694_2686)",
    strokeWidth: 5.64106,
    shapeRendering: "crispEdges"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter5_d_694_2686)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -3.85291,
    y: 1.03239,
    width: 33.8541,
    height: 5.64106,
    rx: 2.82053,
    transform: "matrix(-0.866025 -0.5 -0.5 0.866025 61.7035 116.653)",
    stroke: "url(#paint3_radial_694_2686)",
    strokeWidth: 5.64106,
    shapeRendering: "crispEdges"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter6_d_694_2686)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -2.7,
    y: -2.7,
    width: 34.2,
    height: 5.4,
    rx: 2.7,
    transform: "matrix(0 -1 -1 0 28.1996 85.8002)",
    stroke: "url(#paint4_radial_694_2686)",
    strokeWidth: 5.4,
    shapeRendering: "crispEdges"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter7_d_694_2686)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -2.7,
    y: -2.7,
    width: 34.2,
    height: 5.4,
    rx: 2.7,
    transform: "matrix(0 -1 -1 0 115.8 85.8002)",
    stroke: "url(#paint5_radial_694_2686)",
    strokeWidth: 5.4,
    shapeRendering: "crispEdges"
  }))), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 14.1065,
    cy: 14.1065,
    rx: 14.1065,
    ry: 14.1065,
    transform: "matrix(0 -1 -1 0 86.0596 34.2129)",
    fill: "url(#paint6_radial_694_2686)"
  })), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter8_f_694_2686)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 5.12964,
    cy: 5.12964,
    rx: 5.12964,
    ry: 5.12964,
    transform: "matrix(0.132002 0.991249 0.991249 -0.132002 68.2568 11.853)",
    fill: "#9CF2FF"
  }))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter9_d_694_2686)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 66.7809,
    y: 24.9989,
    width: 33.8541,
    height: 5.64106,
    rx: 2.82053,
    transform: "rotate(150 66.7809 24.9989)",
    stroke: "url(#paint7_radial_694_2686)",
    strokeWidth: 5.64106,
    shapeRendering: "crispEdges"
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 14.1065,
    cy: 14.1065,
    r: 14.1065,
    transform: "matrix(-0.866025 -0.5 -0.5 0.866025 47.3301 40.2666)",
    fill: "url(#paint8_radial_694_2686)"
  })), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter10_f_694_2686)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 5.12964,
    cy: 5.12964,
    r: 5.12964,
    transform: "matrix(0.924448 0.381307 0.381307 -0.924448 19.0645 44.5049)",
    fill: "#9CF2FF"
  }))), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter11_d_694_2686)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 3.85292,
    y: -1.03239,
    width: 33.8541,
    height: 5.64106,
    rx: 2.82053,
    transform: "matrix(0.866025 0.5 0.5 -0.866025 75.0402 22.1783)",
    stroke: "url(#paint9_radial_694_2686)",
    strokeWidth: 5.64106,
    shapeRendering: "crispEdges"
  }))), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 14.1065,
    cy: 14.1065,
    r: 14.1065,
    transform: "matrix(0.866025 -0.5 -0.5 -0.866025 110.777 64.604)",
    fill: "url(#paint10_radial_694_2686)"
  })), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter12_f_694_2686)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 5.12964,
    cy: 5.12964,
    r: 5.12964,
    transform: "matrix(-0.792446 0.609942 0.609942 0.792446 121.24 38.0063)",
    fill: "#9CF2FF"
  }))), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter13_d_694_2686)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -1.03239,
    y: 3.85292,
    width: 28.2162,
    height: 5.64106,
    rx: 2.82053,
    transform: "matrix(-0.866025 0.5 0.5 0.866025 103.891 44.5846)",
    stroke: "url(#paint11_radial_694_2686)",
    strokeWidth: 5.64106,
    shapeRendering: "crispEdges"
  }))), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter14_d_694_2686)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 3.85179,
    y: -1.03208,
    width: 28.215,
    height: 5.63941,
    rx: 2.8197,
    transform: "matrix(0.866025 0.5 0.5 -0.866025 31.6473 49.5657)",
    stroke: "url(#paint12_radial_694_2686)",
    strokeWidth: 5.63941,
    shapeRendering: "crispEdges"
  }))), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 72.0029,
    cy: 124.413,
    rx: 14.1065,
    ry: 14.1065,
    transform: "rotate(90 72.0029 124.413)",
    fill: "url(#paint13_radial_694_2686)"
  })), _g16 || (_g16 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter15_f_694_2686)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 74.0685,
    cy: 128.259,
    r: 5.12964,
    transform: "rotate(-82.4147 74.0685 128.259)",
    fill: "#9CF2FF"
  }))), _g17 || (_g17 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter16_d_694_2686)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 69,
    y: 115.8,
    width: 27.6,
    height: 6,
    rx: 3,
    transform: "rotate(-90 69 115.8)",
    stroke: "url(#paint14_radial_694_2686)",
    strokeWidth: 6,
    shapeRendering: "crispEdges"
  }))), _g18 || (_g18 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter17_dii_694_2686)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 72.0046,
    cy: 72.0632,
    r: 16.9265,
    fill: "#63CADA"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 72.0046,
    cy: 72.0632,
    r: 16.9265,
    fill: "url(#paint15_radial_694_2686)",
    fillOpacity: 0.8
  }))), _g19 || (_g19 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter18_f_694_2686)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 68.2381,
    cy: 72.6148,
    r: 6.48849,
    transform: "rotate(-109.415 68.2381 72.6148)",
    fill: "#8CF2FD"
  }))), _g20 || (_g20 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter19_dii_694_2686)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M66.312 33.0488C68.0343 33.7979 69.9353 34.2133 71.9332 34.2133C73.9466 34.2133 75.8614 33.7915 77.5941 33.0315V53.7542C77.5941 56.8697 75.0686 59.3953 71.9531 59.3953C68.8376 59.3953 66.312 56.8697 66.312 53.7542L66.312 33.0488Z",
    fill: "#6BCDDE"
  }))), _g21 || (_g21 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter20_dii_694_2686)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M101.837 97.1268C102.059 95.2949 102.646 93.4766 103.627 91.7776C104.652 90.0014 106.006 88.5327 107.567 87.4036L88.8619 76.6045C86.1631 75.0463 82.712 75.971 81.1538 78.6699C79.5957 81.3687 80.5204 84.8198 83.2192 86.3779L101.837 97.1268Z",
    fill: "#6BCDDE"
  }))), _g22 || (_g22 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter21_dii_694_2686)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M42.0817 97.1159L60.6878 86.3737C63.3859 84.816 64.3103 81.3659 62.7526 78.6679C61.1949 75.9698 57.7448 75.0454 55.0468 76.6031L36.441 87.3452C37.9581 88.4639 39.2744 89.9068 40.2771 91.6437C41.28 93.3807 41.8715 95.2424 42.0817 97.1159Z",
    fill: "#6BCDDE"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_694_2686",
    x: 95.7334,
    y: 77.0884,
    width: 43.2178,
    height: 43.2178,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 1.5
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.75
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_694_2686"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_694_2686",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_f_694_2686",
    x: 104.892,
    y: 83.5189,
    width: 30.6234,
    height: 30.6234,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5.09091,
    result: "effect1_foregroundBlur_694_2686"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_d_694_2686",
    x: 7.95117,
    y: 77.0889,
    width: 43.2178,
    height: 43.2173,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 1.5
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.75
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_694_2686"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_694_2686",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_f_694_2686",
    x: 10.45,
    y: 87.0965,
    width: 30.6254,
    height: 30.6254,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5.09091,
    result: "effect1_foregroundBlur_694_2686"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter4_d_694_2686",
    x: 68.3281,
    y: 88.7578,
    width: 59.7178,
    height: 49.3901,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 6
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 1 0 0 0 0 1 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_694_2686"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_694_2686",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter5_d_694_2686",
    x: 20.5957,
    y: 88.7578,
    width: 59.7178,
    height: 49.3901,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 6
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 1 0 0 0 0 1 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_694_2686"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_694_2686",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter6_d_694_2686",
    x: 12.7998,
    y: 39.6001,
    width: 34.7998,
    height: 63.6001,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 6
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 1 0 0 0 0 1 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_694_2686"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_694_2686",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter7_d_694_2686",
    x: 100.4,
    y: 39.6001,
    width: 34.7998,
    height: 63.6001,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 6
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 1 0 0 0 0 1 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_694_2686"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_694_2686",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter8_f_694_2686",
    x: 58.7069,
    y: 0.948552,
    width: 30.6244,
    height: 30.6244,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5.09091,
    result: "effect1_foregroundBlur_694_2686"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter9_d_694_2686",
    x: 22.8525,
    y: 6.32471,
    width: 59.7178,
    height: 49.3901,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 6
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 1 0 0 0 0 1 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_694_2686"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_694_2686",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter10_f_694_2686",
    x: 10.45,
    y: 26.4061,
    width: 30.6254,
    height: 30.6254,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5.09091,
    result: "effect1_foregroundBlur_694_2686"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter11_d_694_2686",
    x: 66.0713,
    y: 6.32471,
    width: 59.7178,
    height: 49.3901,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 6
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 1 0 0 0 0 1 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_694_2686"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_694_2686",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter12_f_694_2686",
    x: 104.992,
    y: 29.8885,
    width: 30.6234,
    height: 30.6234,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5.09091,
    result: "effect1_foregroundBlur_694_2686"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter13_d_694_2686",
    x: 70.4863,
    y: 33.6162,
    width: 54.835,
    height: 46.5713,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 6
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 1 0 0 0 0 1 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_694_2686"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_694_2686",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter14_d_694_2686",
    x: 22.6787,
    y: 33.7129,
    width: 54.8311,
    height: 46.5684,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 6
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 1 0 0 0 0 1 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_694_2686"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_694_2686",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter15_f_694_2686",
    x: 58.7567,
    y: 112.947,
    width: 30.6244,
    height: 30.6244,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5.09091,
    result: "effect1_foregroundBlur_694_2686"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter16_d_694_2686",
    x: 56,
    y: 73.1997,
    width: 36,
    height: 57.6001,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 6
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 1 0 0 0 0 1 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_694_2686"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_694_2686",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter17_dii_694_2686",
    x: 49.0781,
    y: 47.6367,
    width: 48.8525,
    height: 48.853,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 1.5
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.75
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_694_2686"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_694_2686",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -5
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.75
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.5 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect2_innerShadow_694_2686"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 5,
    dy: -2.5
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.75
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect2_innerShadow_694_2686",
    result: "effect3_innerShadow_694_2686"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter18_f_694_2686",
    x: 51.5662,
    y: 55.9427,
    width: 33.3441,
    height: 33.3441,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5.09091,
    result: "effect1_foregroundBlur_694_2686"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter19_dii_694_2686",
    x: 60.3125,
    y: 25.5312,
    width: 26.2812,
    height: 41.3643,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 1.5
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.75
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_694_2686"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_694_2686",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.75
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.5 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect2_innerShadow_694_2686"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 5,
    dy: -2.5
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.75
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.486275 0 0 0 0 0.835294 0 0 0 0 0.890196 0 0 0 0.5 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect2_innerShadow_694_2686",
    result: "effect3_innerShadow_694_2686"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter20_dii_694_2686",
    x: 74.3965,
    y: 68.3477,
    width: 42.1699,
    height: 36.2793,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 1.5
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.75
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_694_2686"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_694_2686",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.75
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.5 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect2_innerShadow_694_2686"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 5,
    dy: -2.5
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.75
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.486275 0 0 0 0 0.835294 0 0 0 0 0.890196 0 0 0 0.5 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect2_innerShadow_694_2686",
    result: "effect3_innerShadow_694_2686"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter21_dii_694_2686",
    x: 30.4414,
    y: 68.3462,
    width: 42.0684,
    height: 36.2695,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 1.5
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.75
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_694_2686"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_694_2686",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.75
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.5 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect2_innerShadow_694_2686"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 5,
    dy: -2.5
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.75
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.486275 0 0 0 0 0.835294 0 0 0 0 0.890196 0 0 0 0.5 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect2_innerShadow_694_2686",
    result: "effect3_innerShadow_694_2686"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_694_2686",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(105.519 109.726) rotate(-57.5402) scale(24.8497 360.086)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.104167,
    stopColor: "#3A78B1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.520341,
    stopColor: "#4FC1C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8CF2FD"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_694_2686",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(17.7368 109.726) rotate(-57.5402) scale(24.8497 360.086)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.104167,
    stopColor: "#3A78B1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.520341,
    stopColor: "#4FC1C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8CF2FD"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint2_radial_694_2686",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(127.66 122.894) rotate(178.806) scale(58.0042 21.7406)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2B8484"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.652432,
    stopColor: "#74E8E8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.973958,
    stopColor: "#1E5181"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint3_radial_694_2686",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(50.5304 6.03192) rotate(177.783) scale(51.7706 19.4042)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2B8484"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.652432,
    stopColor: "#74E8E8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.973958,
    stopColor: "#1E5181"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint4_radial_694_2686",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(38.7481 6.56529) rotate(-178.553) scale(45.3768 16.2388)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2B8484"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.652432,
    stopColor: "#74E8E8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.973958,
    stopColor: "#1E5181"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint5_radial_694_2686",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(38.7481 6.56529) rotate(-178.553) scale(45.3768 16.2388)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2B8484"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.652432,
    stopColor: "#74E8E8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.973958,
    stopColor: "#1E5181"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint6_radial_694_2686",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(18.1979 3.71377) rotate(104.47) scale(25.546 34.901)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.161458,
    stopColor: "#8CF2FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.520341,
    stopColor: "#4FC1C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.880208,
    stopColor: "#3A78B1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint7_radial_694_2686",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(118.206 30.9012) rotate(179.163) scale(54.1746 60.6941)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2B8484"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.571676,
    stopColor: "#74E8E8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.973958,
    stopColor: "#1E5181"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint8_radial_694_2686",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(18.1979 3.71377) rotate(104.47) scale(25.546 34.901)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.161458,
    stopColor: "#8CF2FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.520341,
    stopColor: "#4FC1C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.880208,
    stopColor: "#3A78B1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint9_radial_694_2686",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(49.0954 5.74943) rotate(-179.909) scale(55.6922 33.225)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2B8484"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.652432,
    stopColor: "#74E8E8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.973958,
    stopColor: "#1E5181"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint10_radial_694_2686",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(18.1979 3.71377) rotate(104.47) scale(25.546 34.901)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.161458,
    stopColor: "#8CF2FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.520341,
    stopColor: "#4FC1C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.880208,
    stopColor: "#3A78B1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint11_radial_694_2686",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(33.1288 6.85837) rotate(-178.232) scale(38.8024 16.9611)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2B8484"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.652432,
    stopColor: "#74E8E8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.973958,
    stopColor: "#1E5181"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint12_radial_694_2686",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(33.1261 6.85637) rotate(-178.232) scale(38.7991 16.9561)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2B8484"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.652432,
    stopColor: "#74E8E8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.973958,
    stopColor: "#1E5181"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint13_radial_694_2686",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(76.0943 114.02) rotate(104.47) scale(25.546 34.901)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.161458,
    stopColor: "#8CF2FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.520341,
    stopColor: "#4FC1C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.880208,
    stopColor: "#3A78B1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint14_radial_694_2686",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(98.8772 126.095) rotate(-178.105) scale(38.5103 18.039)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2B8484"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.652432,
    stopColor: "#74E8E8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.973958,
    stopColor: "#1E5181"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint15_radial_694_2686",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(78.1233 59.2491) rotate(146.296) scale(35.444 45.313)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#32FFCE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.447917,
    stopColor: "#00F0FF"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStable);
export default __webpack_public_path__ + "static/media/stable.a56eeab4.svg";
export { ForwardRef as ReactComponent };